import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withKeys as _withKeys, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-grid" }
const _hoisted_2 = { class: "p-col-9" }
const _hoisted_3 = { style: {"font-weight":"bold"} }
const _hoisted_4 = /*#__PURE__*/_createVNode("i", { class: "bx bx-edit-alt" }, null, -1)
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { style: {"font-weight":"bold"} }
const _hoisted_7 = { class: "p-text-secondary" }
const _hoisted_8 = /*#__PURE__*/_createVNode("i", { class: "bx bx-edit-alt" }, null, -1)
const _hoisted_9 = { key: 3 }
const _hoisted_10 = { class: "p-text-secondary" }
const _hoisted_11 = { class: "p-col-3" }
const _hoisted_12 = { class: "p-grid p-mb-1" }
const _hoisted_13 = { class: "p-col-9 p-d-flex" }
const _hoisted_14 = { class: "p-p-2" }
const _hoisted_15 = { class: "p-col-3 p-d-flex p-justify-end" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "p-menuitem-text" }
const _hoisted_18 = /*#__PURE__*/_createVNode("span", {
  class: "p-ink",
  style: {"height":"186px","width":"186px","top":"-76px","left":"67px"}
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ExperimentTag = _resolveComponent("ExperimentTag")!
  const _component_InlineText = _resolveComponent("InlineText")!
  const _component_Inplace = _resolveComponent("Inplace")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ExperimentStatus = _resolveComponent("ExperimentStatus")!
  const _component_LogDialog = _resolveComponent("LogDialog")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_TabMenu = _resolveComponent("TabMenu")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Skeleton = _resolveComponent("Skeleton")!

  return (_ctx.experimentDetail)
    ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            (_ctx.canEdit())
              ? (_openBlock(), _createBlock(_component_Inplace, {
                  key: 0,
                  active: _ctx.activeEditName,
                  "onUpdate:active": _cache[2] || (_cache[2] = ($event: any) => (_ctx.activeEditName = $event)),
                  onAccept: _ctx.updateCurrenName,
                  onCancel: _ctx.cancelEditName,
                  onKeyup: _withKeys(_ctx.cancelEditName, ["esc"]),
                  class: "p-text-truncate p-text-nowrap"
                }, {
                  display: _withCtx(() => [
                    _createVNode(_component_ExperimentTag, {
                      style: {"border-radius":"5px"},
                      name: 'AUTOML'
                    }),
                    _createVNode("span", _hoisted_3, _toDisplayString(_ctx.experimentDetail.name), 1),
                    _hoisted_4
                  ]),
                  content: _withCtx(() => [
                    _createVNode(_component_InlineText, {
                      model: _ctx.newName,
                      "onUpdate:model": _cache[1] || (_cache[1] = ($event: any) => (_ctx.newName = $event)),
                      onCancel: _ctx.cancelEditName,
                      onAccept: _ctx.updateCurrenName,
                      maxLength: 64
                    }, null, 8, ["model", "onCancel", "onAccept"])
                  ]),
                  _: 1
                }, 8, ["active", "onAccept", "onCancel", "onKeyup"]))
              : (_openBlock(), _createBlock("div", _hoisted_5, [
                  _createVNode(_component_ExperimentTag, {
                    style: {"border-radius":"5px"},
                    name: 'AUTOML'
                  }),
                  _createVNode("span", _hoisted_6, _toDisplayString(_ctx.experimentDetail.name), 1)
                ])),
            (_ctx.canEdit())
              ? (_openBlock(), _createBlock(_component_Inplace, {
                  key: 2,
                  active: _ctx.activeEditDescription,
                  "onUpdate:active": _cache[4] || (_cache[4] = ($event: any) => (_ctx.activeEditDescription = $event)),
                  onAccept: _ctx.updateDescription,
                  onCancel: _ctx.cancelEditDescription,
                  onKeyup: _withKeys(_ctx.cancelEditDescription, ["esc"]),
                  class: "p-text-truncate p-text-nowrap"
                }, {
                  display: _withCtx(() => [
                    _createVNode("span", _hoisted_7, _toDisplayString(_ctx.experimentDetail.description
                  ? _ctx.experimentDetail.description
                  : _ctx.$t("label.edit.description")), 1),
                    _hoisted_8
                  ]),
                  content: _withCtx(() => [
                    _createVNode(_component_InlineText, {
                      model: _ctx.newDescription,
                      "onUpdate:model": _cache[3] || (_cache[3] = ($event: any) => (_ctx.newDescription = $event)),
                      onCancel: _ctx.cancelEditDescription,
                      onAccept: _ctx.updateDescription,
                      maxLength: 512
                    }, null, 8, ["model", "onCancel", "onAccept"])
                  ]),
                  _: 1
                }, 8, ["active", "onAccept", "onCancel", "onKeyup"]))
              : (_openBlock(), _createBlock("div", _hoisted_9, [
                  _createVNode("span", _hoisted_10, _toDisplayString(_ctx.experimentDetail.description
                ? _ctx.experimentDetail.description
                : _ctx.$t("label.no.description")), 1)
                ]))
          ]),
          _createVNode("div", _hoisted_11, [
            (_ctx.canEdit())
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  class: "p-ml-auto p-mr-auto",
                  icon: "pi pi-clone",
                  label: _ctx.$t('button.copy'),
                  onClick: _ctx.copyAutoML,
                  style: {"float":"right"}
                }, null, 8, ["label", "onClick"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode("div", _hoisted_12, [
          _createVNode("div", _hoisted_13, [
            _createVNode("div", _hoisted_14, [
              _createVNode(_component_ExperimentStatus, {
                status: _ctx.experimentDetail.status
              }, null, 8, ["status"])
            ]),
            _createVNode("div", null, [
              (_ctx.experimentDetail.status == 'TRAINING' && _ctx.canEdit())
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    class: "p-button-link p-ml-2",
                    label: _ctx.$t('button.cancel_train'),
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.confirmCancelTrain($event, _ctx.id)))
                  }, null, 8, ["label"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode("div", _hoisted_15, [
            (_ctx.experimentDetail.logMessage)
              ? (_openBlock(), _createBlock("div", _hoisted_16, [
                  _createVNode(_component_LogDialog)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode("div", null, [
          _createVNode(_component_TabMenu, {
            model: _ctx.items,
            class: "p-mb-4"
          }, {
            item: _withCtx(({ item }) => [
              (item.display)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: item.to,
                    class: "p-menuitem-link"
                  }, {
                    default: _withCtx(() => [
                      (item.icon)
                        ? (_openBlock(), _createBlock("span", {
                            key: 0,
                            class: `p-menuitem-icon ${item.icon}`
                          }, null, 2))
                        : _createCommentVNode("", true),
                      _createVNode("span", _hoisted_17, _toDisplayString(_ctx.$t(item.label)), 1),
                      _hoisted_18
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _createVNode(_component_router_view)
      ], 64))
    : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
        _createVNode(_component_Skeleton),
        _createVNode(_component_Skeleton, {
          height: "300px",
          class: "p-mt-4"
        })
      ], 64))
}